
import useScrollAnimation from '../../../hooks/useScrollAnimation';

const BlogHero = () => {
  const { ref: heroRef, isVisible: heroVisible } = useScrollAnimation({ threshold: 0.1 });

  return (
    <section className="relative pt-32 pb-16 px-6 lg:px-12 bg-gradient-to-br from-emerald-900 via-emerald-800 to-emerald-900 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-72 h-72 bg-emerald-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-emerald-300 rounded-full blur-3xl"></div>
      </div>
      <div ref={heroRef} className="max-w-7xl mx-auto relative">
        <div
          className={`flex items-center space-x-2 mb-6 transition-all duration-600 ${
            heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-6'
          }`}
        >
          <span className="inline-block px-4 py-1.5 bg-emerald-700 text-emerald-200 text-xs font-semibold uppercase tracking-wider rounded-full">
            Blog & Recursos
          </span>
        </div>
        <h1
          className={`text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight transition-all duration-700 delay-150 ${
            heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-8'
          }`}
        >
          Blog de <strong>Desguace Gavá</strong>
        </h1>
        <p
          className={`text-lg text-emerald-100 max-w-2xl leading-relaxed transition-all duration-700 delay-300 ${
            heroVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          Artículos especializados sobre <strong>desguaces en Gavá</strong>, reciclaje de vehículos, normativas de baja y consejos para vender tu coche siniestrado al mejor precio en el Baix Llobregat.
        </p>
      </div>
    </section>
  );
};

export default BlogHero;
